// extracted by mini-css-extract-plugin
module.exports = {"select":"NineVerificationPage_select__8s_HD","buttonContainer":"NineVerificationPage_buttonContainer__2LG1a","button":"NineVerificationPage_button__FK85-"};